import { render, staticRenderFns } from "./DeleteGarage.vue?vue&type=template&id=3fbd6096"
import script from "./DeleteGarage.vue?vue&type=script&lang=js"
export * from "./DeleteGarage.vue?vue&type=script&lang=js"
import style0 from "./DeleteGarage.vue?vue&type=style&index=0&id=3fbd6096&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports